import { Controller } from '@hotwired/stimulus'

// Toggles a real_estate_admin's auto-failover eligibility from the Maytapi
// agency modal. The endpoint returns JSON and we restyle the switch in place —
// no HTML injection (avoids the innerHTML/outerHTML XSS sink).
export default class extends Controller {
  static values = { url: String }

  toggle(event) {
    const button = event.currentTarget
    button.disabled = true

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': token,
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({ real_estate_admin_id: button.dataset.adminId }),
    })
      .then((response) => response.json())
      .then(({ enabled }) => this.render(button, enabled))
      .catch((error) => console.error('Maytapi failover toggle failed:', error))
      .finally(() => {
        button.disabled = false
      })
  }

  render(button, enabled) {
    button.classList.toggle('bg-emerald-500', enabled)
    button.classList.toggle('bg-gray-300', !enabled)
    button.setAttribute('aria-pressed', String(enabled))
    button.title = enabled ? 'Recuperação automática ativada' : 'Recuperação automática desativada'

    const knob = button.querySelector('span')
    if (knob) {
      knob.classList.toggle('translate-x-4', enabled)
      knob.classList.toggle('translate-x-0.5', !enabled)
    }
  }
}
